export enum NycbsStatus {
  UNASSIGNED = -1,
  DENIED = 0,
  APPROVED = 1,
  DECSISION_PENDING = 2,
  MARK_AS_COMPLETED = 3,
}
